"use client";

import { FaAngleLeft } from "react-icons/fa";

/**
 * パンくずリスト
 *
 * @param currentPageName 現在のページ名
 * @param breadcrumbItems パンくずリストに表示するページ名とリンク先の配列
 * @returns
 */
const Breadcrumb = ({
  breadcrumbItems,
}: {
  breadcrumbItems: {
    pageName: string;
    onClick: () => void;
  }[];
}) => {
  return (
    <div className="flex items-center">
      {breadcrumbItems.map((breadcrumbItem) => (
        <div
          key={breadcrumbItem.pageName}
          onClick={breadcrumbItem.onClick}
          className="flex cursor-pointer items-center"
        >
          <FaAngleLeft className="text-natural-500 px-2 text-2xl" />
          <span className="pl-2 text-2xl	 text-black">{breadcrumbItem.pageName}</span>
        </div>
      ))}
    </div>
  );
};

export default Breadcrumb;
